import { BaseAnalyticsEvent } from "../types";

/**
 * Отправка события в Roistat
 * @param event событие
 */
export function sendToRoistat(event: BaseAnalyticsEvent) {
	if (!window.roistat?.event?.send) return;
	try {
		window.roistat.event.send(event.eventName, event);
	} catch (err) {
		if (process.env.NODE_ENV === "development") {
			console.warn("[Analytics] Roistat error", err);
		}
	}
}
